import React from 'react';
import { SearchDropdown, SearchItem } from '@/components/ui/search-dropdown';
import type { Category } from '@/types/firebase';

interface CategorySearchProps {
  categories: Category[];
  value: string;
  onChange: (value: string) => void;
  onSelect: (category: Category) => void;
  onAddNew?: () => void;
  onCustomInput?: (value: string) => void; // For free text input
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export function CategorySearch({
  categories,
  value,
  onChange,
  onSelect,
  onAddNew,
  onCustomInput,
  placeholder = 'Search categories...',
  className = '',
  disabled = false
}: CategorySearchProps) {
  // Convert categories to SearchItem format
  const categoryItems: SearchItem[] = categories.map(category => ({
    id: category.id,
    name: category.name,
    originalData: category
  }));

  // Custom filter function for categories
  const filterCategories = (item: SearchItem, searchTerm: string) => {
    const term = searchTerm.toLowerCase();
    return item.name.toLowerCase().includes(term);
  };

  // Custom renderer for category items
  const renderCategoryItem = (item: SearchItem) => {
    return (
      <div
        key={item.id}
        className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer"
        onClick={() => onSelect(item.originalData as Category)}
      >
        <div className="font-medium">{item.name}</div>
      </div>
    );
  };

  return (
    <SearchDropdown
      items={categoryItems}
      value={value}
      onChange={onChange}
      onSelect={(item) => onSelect(item.originalData as Category)}
      onAddNew={onAddNew}
      onCustomInput={onCustomInput}
      addNewLabel="Add New Category"
      placeholder={placeholder}
      emptyMessage="No categories found"
      className={className}
      disabled={disabled}
      renderItem={renderCategoryItem}
      filterFunction={filterCategories}
    />
  );
}
